import React from 'react';

const WhyExportersMove = ({ data }) => {
  if (!data) return null;

  return (
    <section className="bg-[#F9F9FB] py-sp-100 sm:py-sp-big">
      <div className="container px-3">
        <div className="text-center mb-6 sm:mb-8">
          {data.heading && (
            <h2 className="text-[#2C2C2C] text-xxxl sm:text-lg font-medium mx-auto">
              {data.heading}{' '}
              {data.boldHeading && (
                <strong className="font-bold text-[#072F5F]">{data.boldHeading}</strong>
              )}
            </h2>
          )}
        </div>
        <div className="flex flex-wrap">
          {data.cards?.map((card) => (
            <div key={card.id} className="w-1/3 sm:w-full p-1 sm:py-1 sm:p-0 flex">
              <div
                className={`w-full ${card.bgColor} border border-bordercolor rounded-2xl px-3 py-4 flex flex-col justify-start`}
              >
                <div className="flex items-center gap-1 mb-1">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="shrink-0"
                  >
                    <circle cx="10" cy="10" r="10" fill="#059A6D" />
                    <path
                      d="M6 10L9 13L14 7"
                      stroke="#FFFFFF"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <h3 className="text-[#072F5F] font-medium text-base">
                    {card.title}
                  </h3>
                </div>
                <p className="text-[#3C3C3C] text-sm font-normal">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyExportersMove;
